import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LaunchpadUser } from '../../../models/launchpad-user';

@Component({
    selector: 'app-user-grid-entry',
    templateUrl: './user-grid-entry.component.html',
    styleUrls: ['./user-grid-entry.component.sass'],
    standalone: false
})
export class UserGridEntryComponent implements OnInit {
  @Input({ required: true }) user!: LaunchpadUser;
  @Input({ required: true }) loggedInUserEmail!: string;
  @Input() searchTerm: string = '';
  @Input() hasImpersonatorRole: boolean = false;
  @Input() readOnly: boolean = false;

  @Output() editUserClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() detailsClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() toggleUserActiveStatusClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() resendInviteClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() impersonateClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();
  @Output() deleteUserClicked: EventEmitter<LaunchpadUser> = new EventEmitter<LaunchpadUser>();

  isLoggedInUser: boolean = false;
  impersonationRequested: boolean = false;
  isAdminUser: boolean = false;

  /** The deletion of the user has started but failed part way, so it needs retrying */
  get deletionPending(): boolean {
    return this.user.deletionRequestedAt != null;
  }

  ngOnInit() {
    this.isLoggedInUser = this.loggedInUserEmail === this.user.emailAddress.toLowerCase();

      this.impersonationRequested =
        this.user.impersonationExpiry != null && this.user.impersonationExpiry.getTime() > (new Date()).getTime();

      this.isAdminUser = this.user.apps?.some(
        app => app.identifier === 'administration' && app.roles.some(r => r.name === 'Admin')
      ) ?? false;
  }

  editUser() {
    this.editUserClicked.emit();
  }

  showDetails() {
    this.detailsClicked.emit();
  }

  toggleUserActiveStatus() {
    this.toggleUserActiveStatusClicked.emit();
  }

  resendInvite() {
    this.resendInviteClicked.emit(this.user);
  }

  impersonateUser(): void {
    this.impersonateClicked.emit(this.user);
  }

  deleteUser(): void {
    this.deleteUserClicked.emit(this.user);
  }
}
